import { render, staticRenderFns } from "./AgentRenewals.vue?vue&type=template&id=5dcdc8e4&scoped=true"
import script from "./AgentRenewals.vue?vue&type=script&lang=js"
export * from "./AgentRenewals.vue?vue&type=script&lang=js"
import style0 from "./AgentRenewals.vue?vue&type=style&index=0&id=5dcdc8e4&prod&scoped=true&lang=css"
import style1 from "./AgentRenewals.vue?vue&type=style&index=1&id=5dcdc8e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcdc8e4",
  null
  
)

export default component.exports